<template>
  <v-empty-state v-if="emptyStateStore.active" :icon="emptyStateStore.icon">
    <template v-slot:media>
      <v-icon color="surface-variant"></v-icon>
    </template>

    <template v-slot:title>
      <div class="text-h6">{{ emptyStateStore.title }}</div>
    </template>

    <template v-slot:text>
      <div class="text-medium-emphasis text-caption">
        {{ emptyStateStore.description }}
      </div>
    </template>
  </v-empty-state>
</template>
<script setup>
import { useEmptyStateStore } from '../stores/emptyState'
// import { mapGetters } from "vuex";

const emptyStateStore = useEmptyStateStore()

// export default {
//   data() {
//     return {};
//   },
//   computed: {
//     ...mapGetters(["getEmptyState"]),
//   },
// };
</script>
